<template>
  <div class="apply-status-header">
    {{ title }}
    <a-tooltip placement="bottomRight">
      <template #title>
        <div class="result-tips-panel">
          <div class="result-tips-item">
            <div class="result-tips-status">{{ $t('user.Pending') }}</div>
            <div class="result-tips-remark">
              {{ $t(getRemarkText('pending')) }}
            </div>
          </div>
          <div class="result-tips-item">
            <div class="result-tips-status">
              {{ $t('user.Approve for Panel') }}
            </div>
            <div class="result-tips-remark">
              {{ $t(getRemarkText('approve')) }}
            </div>
          </div>
          <div class="result-tips-item">
            <div class="result-tips-status">
              {{ $t('user.Disapprove for Panel') }}
            </div>
            <div class="result-tips-remark">
              {{ $t(getRemarkText('disapprove')) }}
            </div>
          </div>
          <div class="result-tips-item">
            <div class="result-tips-status">{{ $t('user.Reopen') }}</div>
            <div class="result-tips-remark">
              {{ $t(getRemarkText('reopen')) }}
            </div>
          </div>
        </div>
      </template>
      <QuestionCircleFilled />
    </a-tooltip>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { QuestionCircleFilled } from '@ant-design/icons-vue'
  export default {
    name: 'ApplyStatusHeader',
    components: { QuestionCircleFilled },
    props: {
      title: {
        type: String,
        default: 'Panel Result',
      },
      type: {
        typpe: String,
        default: 'rolea',
      },
    },
    data() {
      return {}
    },
    computed: {
      // ...mapGetters({
      //   role: 'acl/role',
      // }),
    },
    methods: {
      isRoleA() {
        return this.role == ['a']
      },
      getRemarkText(key) {
        // const type = this.role == ['a'] ? 'rolea' : 'roleb'
        const dicData = {
          rolea: {
            pending:
              'user.Your applicatinon is waiting for your review manager’s approval.',
            approve: 'user.Your panel review applicatinon has been appproved.',
            disapprove:
              "user.Your panel review application is not approved. Please click details to view your leader's assessment and comments",
            reopen: 'user.Your application is reopened. Please reapply.',
          },
          roleb: {
            pending: 'user.The application is waiting for your approval.',
            approve: 'user.The panel review application has been approved.',
            disapprove:
              'user.The panel review application is not approved. Please have a career dialog with your team member.',
            reopen:
              "user.Your team member's application is reopened. Please wait for your team member to reapply.",
          },
          rolec: {
            pending: `user.The application is waiting for review manager's approval.`,
            approve: 'user.The panel review application has been approved.',
            disapprove: 'user.The panel review application is not approved.',
            reopen: "user.The talent's application is reopened.",
          },
          roled: {
            pending:
              'admin.The application is waiting for review manager to review.',
            approve: 'admin.The panel review application has been approved.',
            disapprove: 'admin.The panel review application is not approved.',
            reopen: "admin.The talent's application is reopened.",
          },
        }
        const res = dicData[this.type] || dicData['rolea']
        return res[key]
      },
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');
  .apply-status-header {
    // text-align: center;
  }
  .result-tips-panel {
    width: 388px;
    // height: 295px;
    .result-tips-item {
      width: 100%;
      min-height: 58px;
      padding: 12px 16px;
      min-width: 114px;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #ffffff;
      line-height: 20px;
      border-bottom: 1px solid #e9e9e980;
      &:last-child {
        border-bottom: none;
      }
    }
    .result-tips-status {
      width: 120px;
    }
    .result-tips-remark {
      width: 208px;
    }
  }
</style>
